import { CurrentTransactionHandler } from "@type/core/transaction/transaction.types";
import { useUnit } from "effector-react/compat";
import { currentTransactionStore } from "@state/transactions/CurrentTransactionStore";

export const useCurrentTransaction = (): CurrentTransactionHandler => {
  const currentTransactionHandler = useUnit<CurrentTransactionHandler>(
    currentTransactionStore,
  );

  return currentTransactionHandler;
};
